import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRedux } from "helpers";
import * as styles from "./authentication.styles";
import { H5, P } from "../newStyles.styles";
import { displayError } from "helpers";
import Button from "@material-ui/core/Button";

class Login extends Component {
  state = {
    email: "",
    password: "",
    isPreFilled: false,
  };

  componentWillUpdate(currentProp) {
    const { formPreFillInfo } = currentProp;
    if (formPreFillInfo.email && !this.state.email) {
      this.setState({
        ...this.state,
        ...formPreFillInfo,
        isPreFilled: true,
      });
    }
  }

  update = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  login = (e) => {
    e.preventDefault();
    let { error, ...user } = this.state;
    const { email, password, firstName, lastName, phone } = user;
    const { isWeb, callback } = this.props;

    if (!email) return displayError("Email can't be empty.");

    if (callback) callback();

    if (email && password) {
      this.props.actions.login(user, isWeb);
    } else {
      displayError("Invalid email or password!");
    }
  };

  render() {
    const { email, password, isPreFilled } = this.state;

    const { width, customColor } = this.props;

    return (
      <div
        style={{
          padding: "0px 15px 15px 15px",
          alignSelf: "center",
          backgroundColor: "white",
        }}
      >
        <H5 style={{ textAlign: "center", marginBlockStart: "0px" }}>Login</H5>
        <form
          className={styles.flexColumn}
          onSubmit={this.login}
          style={{
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <div className={styles.flexRow}>
            <input
              className={styles.inputStyle}
              style={{
                width: "50%",
                background: isPreFilled ? "#dcdcdc" : "white",
              }}
              autoFocus="email"
              type="text"
              name="email"
              placeholder="Email"
              value={email}
              disabled={isPreFilled}
              onChange={this.update}
            />
          </div>
          <div className={styles.flexRow}>
            <input
              className={styles.inputStyle}
              style={{
                width: "50%",
              }}
              type="password"
              name="password"
              // autoFocus='password'
              placeholder="Password"
              value={password}
              onChange={this.update}
            />
          </div>

          <div
            className={styles.flexColumn}
            style={{
              margin: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <styles.WebButton
                background={
                  customColor
                    ? this.props.activeApp.view.navigation.navBarColor
                    : "#465362"
                }
                onClick={this.login}
              >
                Log In!
              </styles.WebButton>
            </div>
            <Link
              className={styles.unStyledButton}
              style={{ textAlign: "center" }}
              target="_blank"
              to="/forgot-password"
            >
              Forgot Password?
            </Link>
          </div>
          <p
            style={{
              color: "black",
              margin: "15px 0px",
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            By using this website, you're agreeing to our{" "}
            <a style={{ cursor: "pointer" }} href="/terms" target="_blank">
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a
              style={{ cursor: "pointer" }}
              href="/privacy_policy"
              target="_blank"
            >
              Privacy Policy
            </a>
          </p>
        </form>
      </div>
    );
  }
}

export default withRedux(Login);
